const BASE = "/api/v1/notifications";

async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...init,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error((err as { detail?: string }).detail ?? res.statusText);
  }
  return res.json();
}

export interface NotificationItem {
  id: string;
  type: string;
  title: string;
  message: string;
  link: string | null;
  is_read: boolean;
  related_initiative_id: string | null;
  created_at: string | null;
}

export const notificationService = {
  list: (unreadOnly = false, limit = 20, offset = 0): Promise<NotificationItem[]> =>
    request<NotificationItem[]>(
      `${BASE}?unread_only=${unreadOnly}&limit=${limit}&offset=${offset}`
    ),

  unreadCount: (): Promise<{ count: number }> =>
    request<{ count: number }>(`${BASE}/unread-count`),

  markRead: (id: string): Promise<void> =>
    request<void>(`${BASE}/${id}/read`, { method: "PATCH" }),

  markAllRead: (): Promise<void> =>
    request<void>(`${BASE}/read-all`, { method: "PATCH" }),
};
